/**
 * Check to see if the error code is one that would be returned form the signalling server
 * and describes an authentication error
 */
export default function isWSAuthErrorCode(event: CloseEvent): boolean {
  switch (event.code) {
    case 4401:
      return true;
    case 4403:
      return true;
    default:
      return false;
  }
}
